import React from "react";
import PackageAttractionsProfileSection from "../PackageAttractionsProfileSection/PackageAttractionsProfileSection";
import { ldsYyyymmddToIso } from "../AttractionsUpsellBlock/AttractionsUpsellBlock";

/**
 * מיפוי הקשר הצעת טיסה (סוכן) ל־PackageAttractionsProfileSection.
 * נפרד מהפרופיל כדי לא להעמיס תנאי variant על לוגיקת הלקוח.
 *
 * מקורות:
 * - dynamicPackageId — מזהה החבילה בנתיב
 * - תאריכי יציאה/חזרה — offer.dep_date / ret_date (פורמט LDS YYYYMMDD)
 * - נוסעים — partySize מההורה (flattenPassengers)
 * - flight_scope_value — ldsorderid לחוקי scope flight (אם הוגדרו בשרת)
 *
 * destination פנימי (internal_hotel_destinations) — אם יתווסף ל־API ההצעה, מעבירים ל־destinationId.
 */
export default function FlightProposalAttractionsSection({
  dynamicPackageId,
  offer = null,
  proposal = null,
  partySize = 1,
  /** מזהה יעד פנימי לאטרקציות — אופציונלי אם יתווסף ל-payload */
  attractionDestinationId = null,
}) {
  if (dynamicPackageId == null || Number.isNaN(Number(dynamicPackageId))) {
    return null;
  }

  const visitIso = ldsYyyymmddToIso(offer?.dep_date);
  const retIso = ldsYyyymmddToIso(offer?.ret_date);
  const flightScopeValue =
    proposal?.ldsorderid != null && String(proposal.ldsorderid).trim() !== ""
      ? String(proposal.ldsorderid)
      : undefined;

  return (
    <PackageAttractionsProfileSection
      variant="flightProposal"
      dynamicPackageId={Number(dynamicPackageId)}
      destinationId={attractionDestinationId ?? undefined}
      flightScopeValue={flightScopeValue}
      visitDate={visitIso || undefined}
      dateFrom={visitIso || undefined}
      dateTo={retIso || undefined}
      partySize={Math.max(1, Number(partySize) || 1)}
      upgradesSectionTitle="הוספת אטרקציות בתשלום נפרד"
      flightSectionTitle="חוויות והטבות בחבילה"
    />
  );
}
